import React, { useContext, useEffect, useState } from "react";
import ApplicatonContext from "../../context/index";
import ProposalForm from "./indexForm";
import CircularProgress from "@material-ui/core/CircularProgress";
import useApi from "../../hooks/useApi";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box } from "@material-ui/core";
import { useStyles } from "./indexFormStyles";
import { useHistory } from "react-router";
import { ReducerUtils } from "../../constants/reducers";
import { Utils } from "../../constants/utils";
import {
  formFields,
  initialFormState,
  touchFieldsObject,
} from "../../defaultValues/index";
import {
  buildGeneratePaymentLinkPayload,
  buildInitiateClaimPayload,
  buildRazorpayResponseErrorMessage,
  buildSubmitClaimInput,
  buildSystemErrorMessage,
  buildServiceCentreUrl,
  isCopaymentRequired,
  isLoginViaMasterOtp,
  validateInputsLength,
} from "../../helpers/proposal";
import {
  getCurrentDate,
  getPreferredMaxDate,
  getPreferredMinDate,
  // isValidDate,
} from "../../helpers/date";
import { getWebService, postWebService } from "../../helpers/server";
import {
  getApplicationRoute,
  getQueryStringParameterValue,
  getStorageItem,
  logout,
  navigateToUrl,
  parseMessage,
  setStorageItem,
} from "../../helpers/utils";
import { validations } from "../../messages/validation";
import {
  CONFIG_ENTITY_ID,
  CONFIG_ENTITY_NAME,
  DOCUMENT_TPYE_ID_MOBILE_PHOTOS,
  MODAL_KEY_PREMIUM,
  NO_ACTIVE_POLICY_TO_CLAIM_TEXT,
  RAZORPAY_OPTIONS_CURRENCY,
  RAZORPAY_OPTIONS_ENTITY_NAME,
  RAZORPAY_OPTIONS_NAME,
  RAZORPAY_OPTIONS_DESCRIPTION,
  RAZORPAY_OPTIONS_IMAGE,
} from "../../constants/index";
import {
  FORM_FIELD_STATE_ID,
  FORM_FIELD_CITY_ID,
  FORM_FIELD_SERVICE_CENTRE_ID,
  FORM_FIELD_DAMAGE_DETAILS,
  FORM_FIELD_PREFERRED_DATE,
  FORM_FIELD_PREFERRED_TIMESLOT,
  DAMAGE_DETAIL_MIN_CHAR_LENGTH,
} from "../../constants/field";
import moment from "moment";

function Proposal({ classes: { loaderBox } }) {
  const refId = getQueryStringParameterValue("ref");
  const orderId = getStorageItem("proposalId") ?? null;
  const mobile = getStorageItem("mobile") ?? null;
  const orderDetails = useApi(
    orderId ? `lending/proposal?mobile=${mobile}` : "/data/no-order.json"
  );
  const { state, dispatch } = useContext(ApplicatonContext);
  const history = useHistory();
  const [claim, setClaim] = useState(getQueryStringParameterValue("claim"));
  const [errorMessage, setErrorMessage] = useState(formFields);
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState(initialFormState);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isServiceCentreFormSubmitted, setIsServiceCentreFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isManufacturerChanged, setIsManufacturerChanged] = useState(false);
  const [isModelChanged, setIsModelChanged] = useState(false);
  const [isManufacturerVisible, setIsManufacturerVisible] = useState(true);
  const [isModelVisible, setIsModelVisible] = useState(true);
  const [isVariantVisible, setIsVariantVisible] = useState(true);
  const [touchFields, setTouchFields] = useState(touchFieldsObject);
  const [isSearchCompleted, setIsSearchCompleted] = useState(true);
  const [noSearchResultFound, setNoSearchResultFound] = useState([]);
  const [disabledAccordion, setDisabledAccordion] = useState(false);
  const [photo, setPhoto] = useState({ estimate: "", aadhaar: "", phone: "" });

  useEffect(() => {
    fetchProductConfig();
    fetchStates();
  }, []);

  useEffect(() => {}, [orderDetails]);
  useEffect(() => {}, [photo.estimate]);
  useEffect(() => {}, [photo.aadhaar]);
  useEffect(() => {}, [photo.phone]);

  useEffect(() => {
    claim && displayRazorpay(claim);
  }, [claim]);

  useEffect(
    () => {
      validateRequiredInput(FORM_FIELD_DAMAGE_DETAILS);
      const isValid = validateInputsLength(form[FORM_FIELD_DAMAGE_DETAILS]);
      if(isValid) {
        let remainingChars = parseInt(DAMAGE_DETAIL_MIN_CHAR_LENGTH) - parseInt(form[FORM_FIELD_DAMAGE_DETAILS].length);
        setErrorMessage({ ...errorMessage, [FORM_FIELD_DAMAGE_DETAILS]: validations[FORM_FIELD_DAMAGE_DETAILS].min.replace("{WORD_LIMIT}", remainingChars) })
      }
    },
    [form[FORM_FIELD_DAMAGE_DETAILS]]
  );

  useEffect(() => {
    // For vehicle manufacturer change, need to set vehicle model as empty value
    if (form[FORM_FIELD_CITY_ID]) {
      setFormState(FORM_FIELD_CITY_ID, "");
    }

    validateRequiredInput(FORM_FIELD_STATE_ID);
    if (form[FORM_FIELD_STATE_ID]) {
      fetchCities();
    }
  }, [form[FORM_FIELD_STATE_ID]]);

  useEffect(() => {
    // For vehicle model change, need to set vehicle variant as empty value
    if (form[FORM_FIELD_SERVICE_CENTRE_ID]) {
      setFormState(FORM_FIELD_SERVICE_CENTRE_ID, "");
    }

    validateRequiredInput(FORM_FIELD_CITY_ID);
    if (form[FORM_FIELD_CITY_ID]) {
      fetchServiceCentres();
    }
  }, [form[FORM_FIELD_CITY_ID]]);

  useEffect(
    () => validateRequiredInput(FORM_FIELD_SERVICE_CENTRE_ID),
    [form[FORM_FIELD_SERVICE_CENTRE_ID]]
  );

  useEffect(() => {
    setFormState(FORM_FIELD_PREFERRED_TIMESLOT, "");
    validatePreferredDate(FORM_FIELD_PREFERRED_DATE);
  }, [form[FORM_FIELD_PREFERRED_DATE]]);

  /* Start: Vehicle Details Section */
  const setStateCityServiceCentreSectionVisibility = (flag) => {
    setIsManufacturerVisible(flag);
    setIsModelVisible(flag);
    setIsVariantVisible(flag);
  };

  const buildCitiesParams = () => {
    return {
      ...buildStatesParams(),
      state_id: form.state_id,
    };
  };

  const buildPhonePhotoRequestPayload = () => {
    const payload = new FormData();
    payload.append("document_type_id", DOCUMENT_TPYE_ID_MOBILE_PHOTOS);
    payload.append("claimDocuments[]", photo.phone);

    return payload;
  };

  const buildServiceCentresParams = () => {
    return {
      ...buildCitiesParams(),
      city_id: form.city_id,
    };
  };

  const buildStatesParams = () => {
    return {};
  };

  const cbError = ({ data: { error_msg }, code = 400 }, modalKey = "") => {
    setIsFormSubmitted(false);
    setIsServiceCentreFormSubmitted(false);
    const message = parseMessage(error_msg);
    if (Array.isArray(message)) {
      setErrors(message);
    } else {
      let messageArray = [];
      messageArray.push(message);
      setErrors(messageArray);
    }

    if (code === 401) {
      doForceLogout();
    }
  };

  const submitClaimInputAndDocument = async (claimId, navigateTo = true) => {
    await submitClaimInput(claimId);
    if (!claim && photo.phone) {
      await submitClaimDocument(claimId, buildPhonePhotoRequestPayload());
    }
    setIsFormSubmitted(false);
    setIsServiceCentreFormSubmitted(false);
    if (navigateTo) {
      navigateToUrl(
        `${getApplicationRoute("acknowledgement")}/${claimId}`,
        history
      );
    }
  };

  const cbUpdateRazorPayPaymentResponse = async ({ success }, entity_id) => {
    if (success) {
      await submitClaimInputAndDocument(entity_id);
    } else {
      console.log("Razorpay Response API Error Handling is required here...");
      setIsFormSubmitted(false);
      setIsServiceCentreFormSubmitted(false);
    }
  };

  const changeOptionBaseOnValue = async (search, field) => {
    // TODO: Need to make an API call using field and response need to populate accordingly like makes, models, variants
  };

  const displayRazorpay = async (claimId) => {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const result = await postWebService("initiateRazorpay", {
      entity: RAZORPAY_OPTIONS_ENTITY_NAME,
      entity_id: claimId,
    });

    if (!result) {
      alert("Server error. Are you online?");
      return;
    }

    const {
      data: {
        amount,
        rp_order_id: order_id,
        currency = RAZORPAY_OPTIONS_CURRENCY,
        key,
      },
    } = result.data;

    const options = {
      key: key,
      amount: amount.toString(),
      currency: currency,
      // name: RAZORPAY_OPTIONS_NAME,
      description: RAZORPAY_OPTIONS_DESCRIPTION,
      // image: RAZORPAY_OPTIONS_IMAGE,
      order_id: order_id,
      handler: async function (response) {
        await updateRazorPayPaymentResponse(response, claimId);
      },
      prefill: {
        name: state?.orderDetails?.name,
        email: state?.orderDetails?.email,
        contact: state?.orderDetails?.mobile,
      },
      notes: {
        address: state?.orderDetails?.address_line_1,
      },
      // theme: {
      //   color: "#3c63fc",
      // },
      modal: {
        ondismiss: function () {
          setIsFormSubmitted(false);
          setIsServiceCentreFormSubmitted(false);
          claim && navigateTo(getApplicationRoute("dashboard"));
        },
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const doForceLogout = () => {
    // Here setTimeout has been added in order to introduced some delay so that dealer should be able to read error message clearly before redirecting it to login page
    setTimeout(() => {
      logout();
      navigateTo("/");
    }, 1000);
  };

  const fetchCities = async () => {
    const response = await getWebService(
      buildServiceCentreUrl(buildCitiesParams())
    );
    const { data } = response.data;

    dispatchEvent(ReducerUtils.vehicle.models, data);
    setIsModelVisible(true);
  };

  const fetchProductConfig = async () => {
    const response = await getWebService(
      `get_app_config?entity=${CONFIG_ENTITY_NAME}&entity_id=${CONFIG_ENTITY_ID}`
    );
    const {
      data: {
        field_default_value: { title, vehicle_category },
        gst_percentange,
      },
      data,
    } = response.data;

    dispatchEvent(ReducerUtils.products.config, data);

    await searchClickHanlder();
    setIsLoaded(true);
  };

  const fetchRecentOrderForClaim = async () => {
    const response = await getWebService(`search/order/${form.mobile}`);
    const { data } = response.data;

    return data;
  };

  const fetchServiceCentres = async () => {
    const response = await getWebService(
      buildServiceCentreUrl(buildServiceCentresParams())
    );
    const { data } = response.data;

    dispatchEvent(ReducerUtils.vehicle.variants, data);
    setIsVariantVisible(true);
  };

  const fetchStates = async () => {
    setStateCityServiceCentreSectionVisibility(false);

    const response = await getWebService(
      buildServiceCentreUrl(buildStatesParams())
    );
    const { data } = response.data;

    dispatchEvent(ReducerUtils.vehicle.makes, data);
    setStateCityServiceCentreSectionVisibility(true);
  };

  const handleAutocompleteChange = (field, value) => {
    setFormState(field, value);

    if (field === FORM_FIELD_STATE_ID) {
      setIsManufacturerChanged(true);
      setIsModelVisible(false);
    }

    if (field === FORM_FIELD_CITY_ID) {
      setIsModelChanged(true);
      setIsVariantVisible(false);
    }
  };

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const handleChangeChipSelect = (name, value) => {
    setFormState(name, value);
  };

  const handleOnClose = (event, reason, modalKey = MODAL_KEY_PREMIUM) => {
    // Preventing from closing dialog either on escape key press and backdrop click
    if (Utils.dialogOnCloseReasons.indexOf(reason) > -1) {
      event.preventDefault();
    }
  };

  const submitGeneratePaymentLink = async (entity_id) => {
    try {
      await postWebService(
        "payments/link",
        buildGeneratePaymentLinkPayload(entity_id)
      );

      navigateToUrl(getApplicationRoute("dashboard"), history);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const handleLoginViaOTP = async (entity_id) => {
    await submitClaimInputAndDocument(entity_id, false);
    await submitGeneratePaymentLink(entity_id);
  };

  const cbInitiateClaim = (
    { data: { claimId = null }, success },
    eventType
  ) => {
    if (success) {
      setStorageItem("claimId", claimId);
    }

    if (eventType === "service_centre_pay_now") {
      isCopaymentRequired(state?.orderDetails?.product_id)
        ? displayRazorpay(claimId)
        : submitClaimInputAndDocument(claimId);
    } else {
      isCopaymentRequired(state?.orderDetails?.product_id)
        ? isLoginViaMasterOtp()
          ? handleLoginViaOTP(claimId)
          : displayRazorpay(claimId)
        : submitClaimInputAndDocument(claimId);
    }
  };

  const initiateClaim = async (eventType) => {
    try {
      if (eventType === "service_centre_pay_now") {
        setIsServiceCentreFormSubmitted(true);
      } else {
        setIsFormSubmitted(true);
      }
      const response = await postWebService(
        `web/claim/initiate/${form.toffee_id}`,
        buildInitiateClaimPayload(
          state?.orderDetails?.product_id,
          form
        )
      );

      cbInitiateClaim(response.data, eventType);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const navigateTo = (pathname) => history.push({ pathname });

  const onSubmit = (event) => {
    event.preventDefault();
    
    initiateClaim(event.type);
  };

  const photoChangeHandler = (keyname, file) => {
    setPhoto({
      ...photo,
      [keyname]: file,
    });
  };

  const searchClickHanlder = async () => {
    setNoSearchResultFound([]);
    setDisabledAccordion(false);
    setIsSearchCompleted(false);
    setPhoto({ estimate: "", aadhaar: "", phone: "" });

    const order = refId ? { id: refId } : await fetchRecentOrderForClaim();

    if (order) {
      const response = await getWebService(`orders/${order.id}/details/dealer`);
      const { data } = response.data;

      dispatchEvent(ReducerUtils.order.details, data);
      setDisabledAccordion(false);
      setIsSearchCompleted(true);
    } else {
      setNoSearchResultFound([NO_ACTIVE_POLICY_TO_CLAIM_TEXT]);
      dispatchEvent(ReducerUtils.order.details, null);
      setDisabledAccordion(true);
      setIsSearchCompleted(true);
    }
  };

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const submitClaimInput = async (claimId) => {
    const payload = buildSubmitClaimInput();
    const response = await postWebService(
      `web/claim/inputs/${claimId}`,
      payload
    );

    const { data } = response.data;
  };

  const submitClaimDocument = async (claimId, payload) => {
    const response = await postWebService(
      `web/claim/document/submit/${claimId}`,
      payload
    );
    const { data } = response.data;
  };

  const updateRazorPayPaymentResponse = async (
    { razorpay_payment_id, razorpay_signature, razorpay_order_id },
    entity_id = null
  ) => {
    try {
      const payload = {
        entity: "claim",
        entity_id,
        is_recurring: false,
        is_monthly: false,
        take_first_payment: false,
        razorpay_payment_id,
        razorpay_signature,
        razorpay_order_id,
      };
      const response = await postWebService("razorpay/response", payload);

      cbUpdateRazorPayPaymentResponse(response.data, entity_id);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildRazorpayResponseErrorMessage()
      );
    }
  };

  const validateRequiredInput = (fieldName) => {
    if (form[fieldName]) {
      setTouchFieldsState(fieldName, true);
      setErrorMessageState(fieldName, "");
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validatePreferredDate = (fieldName) => {
    if (form[fieldName]) {
      const minDate = getPreferredMinDate();
      const maxDate = getPreferredMaxDate();
      if (moment(form.preferred_date).isBefore(minDate)) {
        setErrorMessageState(fieldName, validations[fieldName].min);
      } else if (moment(form.preferred_date).isAfter(maxDate)) {
        setErrorMessageState(fieldName, validations[fieldName].max);
      } else {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      }
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  return (isLoaded && state.productConfig && !orderId) ||
    (orderId && state.orderDetails) ? (
    <ProposalForm
      changeOptionBaseOnValue={changeOptionBaseOnValue}
      claim={claim}
      disabledAccordion={disabledAccordion}
      errorMessage={errorMessage}
      errors={errors}
      form={form}
      handleAutocompleteChange={handleAutocompleteChange}
      handleChange={handleChange}
      handleChangeChipSelect={handleChangeChipSelect}
      handleOnClose={handleOnClose}
      searchClickHanlder={searchClickHanlder}
      isFormSubmitted={isFormSubmitted}
      isManufacturerChanged={isManufacturerChanged}
      isModelChanged={isModelChanged}
      isManufacturerVisible={isManufacturerVisible}
      isModelVisible={isModelVisible}
      isVariantVisible={isVariantVisible}
      isSearchCompleted={isSearchCompleted}
      noSearchResultFound={noSearchResultFound}
      onSubmit={onSubmit}
      photo={photo}
      photoChangeHandler={photoChangeHandler}
      setForm={setForm}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(Proposal);
